import BanDeviceDialog from "../containers/banDialog";
import { BanTableColumnCaptions } from "./tableColumnCaptions";
import FilterTable from "./filterTable";
import React from "react";

const banStatusFilterValues = { "all": "", "No ban (0)": "0", "GZ (1)": "1", "XML (2)": "2" };

const BannedDevicesTable = (props) => {
  const columns = [
    {
      dataField: "id",
      text: BanTableColumnCaptions.id,
      sort: true,
      filter_: { type: "text" },
    },
    {
      dataField: "device.id",
      text: BanTableColumnCaptions.device.id,
      sort: true,
      filter_: { type: "text" },
    },
    {
      dataField: "device.key",
      text: BanTableColumnCaptions.device.key,
      sort: true,
      filter_: { type: "text" },
    },
    {
      dataField: "banStatus",
      text: BanTableColumnCaptions.banStatus,
      sort: true,
      filter_: {
        type: "select",
        values: banStatusFilterValues,
      },
      formatter: (cell) => `${BanDeviceDialog.BanStatusCaptions[cell]}`,
    },
  ];

  const defaultSorted = [
    {
      dataField: "id",
      order: "desc",
    },
  ];

  return (
    <FilterTable
      {...props}
      objectName="bannedDevices"
      data={props.bannedDevices}
      columns={columns}
      noDataIndication="There are no ban devices"
      defaultSorted={defaultSorted}
    />
  );
};

export default BannedDevicesTable;



// WEBPACK FOOTER //
// ./src/components/bannedDevicesTable.js